import "sharer.js/sharer.min.js";

export default function share() {
  $(".block.share").each(function() {
    const $block = $(this);
    const $pageTitle = $("title");

    /**
     * Twitter share text
     */
    const $twitter = $block.find('[data-sharer="twitter"]');

    const $twitterTitle = $('meta[name="twitter:title"]');
    const $twitterDescription = $('meta[name="twitter:description"]');

    let twitterTitle = $pageTitle.text();

    if ($twitterTitle.length) {
      twitterTitle = $twitterTitle.attr("content");
    }

    if ($twitterDescription.length) {
      twitterTitle += " " + $twitterDescription.attr("content");
    }

    $twitter.attr("data-title", twitterTitle);
  });
}
